import type { CrmTranslate } from './crm-copy';

export function createCrmCustomObjectsCopy(t: CrmTranslate) {
  return {
    customObjects: {
      navSection: t('crm.customObjects.navSection'),
      section: {
        title: t('crm.customObjects.section.title'),
        description: t('crm.customObjects.section.description'),
        empty: t('crm.customObjects.section.empty'),
        readOnly: t('crm.customObjects.section.readOnly'),
        loadFailed: t('crm.customObjects.section.loadFailed'),
        packManaged: (pack: string) =>
          t('crm.customObjects.section.packManaged', {
            values: { pack },
          }),
      },
      labels: {
        singular: t('crm.customObjects.labels.singular'),
        plural: t('crm.customObjects.labels.plural'),
        key: t('crm.customObjects.labels.key'),
        keyHint: t('crm.customObjects.labels.keyHint'),
        description: t('crm.customObjects.labels.description'),
        boardField: t('crm.customObjects.labels.boardField'),
        boardFieldHint: t('crm.customObjects.labels.boardFieldHint'),
        noBoard: t('crm.customObjects.labels.noBoard'),
        name: t('crm.customObjects.labels.name'),
        updated: t('crm.customObjects.labels.updated'),
        unassigned: t('crm.customObjects.labels.unassigned'),
      },
      actions: {
        add: t('crm.customObjects.actions.add'),
        create: t('crm.customObjects.actions.create'),
        save: t('crm.customObjects.actions.save'),
        cancel: t('crm.customObjects.actions.cancel'),
        edit: t('crm.customObjects.actions.edit'),
        delete: t('crm.customObjects.actions.delete'),
        deleteTitle: t('crm.customObjects.actions.deleteTitle'),
        confirmDelete: (label: string) =>
          t('crm.customObjects.actions.confirmDelete', {
            values: { label },
          }),
        manageFields: t('crm.customObjects.actions.manageFields'),
      },
      messages: {
        created: t('crm.customObjects.messages.created'),
        updated: t('crm.customObjects.messages.updated'),
        deleted: t('crm.customObjects.messages.deleted'),
        saveFailed: t('crm.customObjects.messages.saveFailed'),
        deleteFailed: t('crm.customObjects.messages.deleteFailed'),
      },
      records: {
        searchPlaceholder: (plural: string) =>
          t('crm.customObjects.records.searchPlaceholder', {
            values: { plural },
          }),
        create: (singular: string) =>
          t('crm.customObjects.records.create', {
            values: { singular },
          }),
        edit: (singular: string) =>
          t('crm.customObjects.records.edit', {
            values: { singular },
          }),
        empty: (plural: string) =>
          t('crm.customObjects.records.empty', {
            values: { plural },
          }),
        notFound: t('crm.customObjects.records.notFound'),
        recordNotFound: t('crm.customObjects.records.recordNotFound'),
        loadFailed: t('crm.customObjects.records.loadFailed'),
        listView: t('crm.customObjects.records.listView'),
        boardView: t('crm.customObjects.records.boardView'),
        back: (plural: string) =>
          t('crm.customObjects.records.back', {
            values: { plural },
          }),
        details: t('crm.customObjects.records.details'),
        confirmDelete: (name: string) =>
          t('crm.customObjects.records.confirmDelete', {
            values: { name },
          }),
        deleteTitle: t('crm.customObjects.records.deleteTitle'),
        nameRequired: t('crm.customObjects.records.nameRequired'),
        created: t('crm.customObjects.records.created'),
        updated: t('crm.customObjects.records.updated'),
        deleted: t('crm.customObjects.records.deleted'),
        saveFailed: t('crm.customObjects.records.saveFailed'),
        deleteFailed: t('crm.customObjects.records.deleteFailed'),
        previous: t('crm.customObjects.records.previous'),
        next: t('crm.customObjects.records.next'),
        pageStatus: (page: number, pages: number) =>
          t('crm.customObjects.records.pageStatus', {
            values: { page, pages },
          }),
      },
    },
  };
}
